import React from 'react';
import { FormattedMessage } from 'react-intl';

import DropdownItem from '@atlaskit/dropdown-menu/dropdown-menu-item';
import TerminalIcon from '@atlaskit/icon-lab/core/terminal';

import { useOpenAgentsAwarenessModal } from './useOpenAgentsAwarenessModal.ts';

export const EditWithMcpItem = (): JSX.Element => {
	const openAgentsAwarenessModal = useOpenAgentsAwarenessModal();

	return (
		<DropdownItem
			testId="edit-with-mcp-menu-item"
			elemBefore={<TerminalIcon label="" />}
			onClick={() => openAgentsAwarenessModal({ initialStep: 'mcp-setup' })}
		>
			<FormattedMessage
				id="agents-awareness-modal.edit-with-mcp-item.label"
				defaultMessage="Edit with MCP"
				description="Label for the 'Edit with MCP' item in the page more actions menu"
			/>
		</DropdownItem>
	);
};
